import { FC, useState, useEffect } from 'react';
import clsx from 'clsx';
import { EditableComponent, EditableComponentProps } from '@adobe/aem-react-editable-components';
// import { useDatalayer } from '@marriott/mi-headless-utils';
import { shouldUseMockData } from '../../utils/CommonUtils';
// import { checkCampaignStatus, isUserAuthenticated } from '../../utils/OfferUtils';
import { checkCampaignStatus } from '../../utils/OfferUtils';
import { OffersMBEHeroProps } from './OffersMBEHero.types';
import { StyledOffersMBEHero } from './OffersMBEHero.styles';
import { CountDownTimer } from './CountDownTimer';
import { MBEMessage } from './MBEMessage';
import { getMBEWrapperClass } from './utils/helper';
import { constants } from '../../constants/CommonConstants';

type editableCompOffersMBEHeroPropsWith = EditableComponentProps & OffersMBEHeroProps;

export const OffersMBEHeroConfig = {
  emptyLabel: 'OffersMBEHero',
  isEmpty: () => true,
  resourceType: `mi-aem-offers-spa/components/mbehero`,
};

export const OffersMBEHero: FC<editableCompOffersMBEHeroPropsWith> = props => {
  const { isAuthorMode, offersProductResponse } = props;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [mockProps, setMockProps] = useState<any>({});
  const { offersData, model } = !isAuthorMode ? props : mockProps;
  const { campaignStartDate = '', campaignEndDate = '' } = offersData || {};
  const isMPOVar =
    offersData && Object.keys(offersData).length > 0
      ? false
      : offersProductResponse && Object.keys(offersProductResponse).length > 0
      ? true
      : false;
  const { CAMPAIGN_ACTIVE } = constants;

  //For adding the authetication
  // const { datalayer } = useDatalayer();
  // const [isUserLoggedIn, setIsUserLoggedIn] = useState<boolean>(isUserAuthenticated(datalayer));

  const GetMockData = async (isAuthorMode: boolean) => {
    if (shouldUseMockData(isAuthorMode)) {
      const mockData = await import('./__mock__/OffersMBEHero.mock');
      return mockData.mockProps;
    }
    return {};
  };

  useEffect(() => {
    const fetchMockData = async () => {
      const mockData = await GetMockData(isAuthorMode);
      setMockProps(mockData);
    };

    fetchMockData();
  }, [isAuthorMode]);

  const [variation, setVariation] = useState(() =>
    isMPOVar ? CAMPAIGN_ACTIVE : checkCampaignStatus(campaignStartDate, campaignEndDate)
  );

  useEffect(() => {
    if (!campaignStartDate || !campaignEndDate || isAuthorMode) return;

    const checkStatus = () => {
      const newStatus = checkCampaignStatus(campaignStartDate, campaignEndDate);
      if (newStatus !== variation) {
        setVariation(newStatus);
      }
    };

    checkStatus();
    const interval = setInterval(checkStatus, 1000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignStartDate, campaignEndDate, variation, isAuthorMode]);

  // useEffect(() => {
  //   setIsUserLoggedIn(isUserAuthenticated(datalayer));
  // }, [datalayer]);

  //
  const isUserLoggedIn = false; //The authentication logic is removed as per requirement.

  return (
    <EditableComponent config={OffersMBEHeroConfig} {...props}>
      <StyledOffersMBEHero data-testid="offers-OffersMBEHero" data-component-name="o-offers-OffersMBEHero">
        <div className={clsx(variation === 'inactive' && 'container', 'mbeHero-wrapper')}>
          <div className={clsx(getMBEWrapperClass(isUserLoggedIn, variation))}>
            <div className={clsx('content-wrapper mbe-layout')}>
              <MBEMessage {...{ isMPOVar, variation, isUserLoggedIn, ...props }} />

              {variation === 'inactive' && model?.countdownTimer && (
                <>
                  <div className="vertical-divider"></div>
                  <div className="timer-align">
                    <CountDownTimer
                      startDate={offersData?.campaignStartDate}
                      model={model}
                      isAuthorMode={isAuthorMode}
                      onCountdownComplete={() => setVariation('active')}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </StyledOffersMBEHero>
    </EditableComponent>
  );
};
